module.exports = __webpack_public_path__ + "img/logo_suiminhensachi_white.e050909e.png";